import { render } from "./Connections.vue?vue&type=template&id=3c53ef20"
import script from "./Connections.vue?vue&type=script&lang=ts"
export * from "./Connections.vue?vue&type=script&lang=ts"
script.render = render

export default script